import { useAuth } from '@contexts/AuthContext'

function AuthedOnly({ children }: any) {
  const auth = useAuth()

  return auth.userManager.isAuthed() ? <>{children}</> : null
}

export default AuthedOnly
